import React from 'react';

export const WeBuyProcess: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'Contact Us',
      description: 'Fill out our simple form or give us a call. Tell us about your property and your situation.'
    },
    {
      number: '2',
      title: 'Property Review',
      description: 'We review your property details and financials. No need for extensive repairs or staging.'
    },
    {
      number: '3',
      title: 'Receive Offer',
      description: 'Get a fair, no-obligation cash offer within 24 hours. No pressure, no games.'
    },
    {
      number: '4',
      title: 'Close Fast',
      description: 'Choose your closing date. We handle all the paperwork and close on your schedule.'
    }
  ];

  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Our Simple Process</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From first contact to closing in 4 easy steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500 text-white rounded-full text-2xl font-bold mb-6 mx-auto">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-center">{step.title}</h3>
                <p className="text-gray-600 text-center leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <i className="ri-arrow-right-line text-3xl text-orange-500"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
